import { createContext } from "react";

export const ProcedureContext = createContext({
	openFolders: [] as string[],
	setOpenFolders: (openFolders: string[]) => {
		void openFolders;
	},
	expandAll: false,
	setExpandAll: (expandAll: boolean) => {
		void expandAll;
	},
	activeStep: -1,
	setActiveStep: (activeStep: number) => {
		void activeStep;
	},
	activeChecklistId: 0,
	setActiveChecklistId: (activeChecklistId: number) => {
		void activeChecklistId;
	},
});

export const ProcedureProvider = ProcedureContext.Provider;
export const ProcedureConsumer = ProcedureContext.Consumer;
